module.exports = __webpack_public_path__ + "media/images/top/place/other-place1-09b582d5270f10992e0b59664cbdaf36.png";